<template>
  <b-form-select
    v-model="state_province"
    :name="name"
    :size="size"
    :required="required"
    :options="options"
    :disabled="disabled"
  ></b-form-select>
</template>

<script>
  export default {
    props: {
      value: String,
      name: {
        type: String,
        default: 'state_province',
      },
      size: {
        type: String,
        default: 'md',
      },
      required: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
        state_province: this.value || null,
        options: [
        {value: null, text: trans('state_province')},
        {
          value: 'AB',
          text: trans('province_AB'),
        }, {
          value: 'BC',
          text: trans('province_BC'),
        }, {
          value: 'MB',
          text: trans('province_MB'),
        }, {
          value: 'NB',
          text: trans('province_NB'),
        }, {
          value: 'NL',
          text: trans('province_NL'),
        }, {
          value: 'NT',
          text: trans('province_NT'),
        }, {
          value: 'NS',
          text: trans('province_NS'),
        }, {
          value: 'NU',
          text: trans('province_NU'),
        }, {
          value: 'ON',
          text: trans('province_ON'),
        }, {
          value: 'PE',
          text: trans('province_PE'),
        }, {
          value: 'QC',
          text: trans('province_QC'),
        }, {
          value: 'SK',
          text: trans('province_SK'),
        }, {
          value: 'YT',
          text: trans('province_YT'),
        },
          {value: 'AK', text: 'ALASKA'},
          {value: 'AL', text: 'ALABAMA'},
          {value: 'AR', text: 'ARKANSAS'},
          {value: 'AS', text: 'AMERICAN SAMOA'},
          {value: 'AZ', text: 'ARIZONA'},
          {value: 'CA', text: 'CALIFORNIA'},
          {value: 'CO', text: 'COLORADO'},
          {value: 'CT', text: 'CONNECTICUT'},
          {value: 'DC', text: 'WASHINGTON, DISTRICT OF COLUMBIA'},
          {value: 'DE', text: 'DELAWARE'},
          {value: 'FL', text: 'FLORIDA'},
          {value: 'FM', text: 'FEDERATED STATES OF MICRONESIA'},
          {value: 'GA', text: 'GEORGIA'},
          {value: 'GU', text: 'GUAM'},
          {value: 'HI', text: 'HAWAII'},
          {value: 'IA', text: 'IOWA'},
          {value: 'ID', text: 'IDAHO'},
          {value: 'IL', text: 'ILLINOIS'},
          {value: 'IN', text: 'INDIANA'},
          {value: 'KS', text: 'KANSAS'},
          {value: 'KY', text: 'KENTUCKY'},
          {value: 'LA', text: 'LOUISIANA'},
          {value: 'MA', text: 'MASSACHUSETTS'},
          {value: 'MD', text: 'MARYLAND'},
          {value: 'ME', text: 'MAINE'},
          {value: 'MH', text: 'MARSHALL ISLANDS'},
          {value: 'MI', text: 'MICHIGAN'},
          {value: 'MN', text: 'MINNESOTA'},
          {value: 'MO', text: 'MISSOURI'},
          {value: 'MP', text: 'NORTHERN MARIANA ISLANDS'},
          {value: 'MS', text: 'MISSISSIPPI'},
          {value: 'MT', text: 'MONTANA'},
          {value: 'NC', text: 'NORTH CAROLINA'},
          {value: 'ND', text: 'NORTH DAKOTA'},
          {value: 'NE', text: 'NEBRASKA'},
          {value: 'NH', text: 'NEW HAMPSHIRE'},
          {value: 'NJ', text: 'NEW JERSEY'},
          {value: 'NM', text: 'NEW MEXICO'},
          {value: 'NV', text: 'NEVADA'},
          {value: 'NY', text: 'NEW YORK'},
          {value: 'OH', text: 'OHIO'},
          {value: 'OK', text: 'OKLAHOMA'},
          {value: 'OR', text: 'OREGON'},
          {value: 'PA', text: 'PENNSYLVANIA'},
          {value: 'PR', text: 'PUERTO RICO'},
          {value: 'PW', text: 'PALAU'},
          {value: 'RI', text: 'RHODE ISLAND'},
          {value: 'SC', text: 'SOUTH CAROLINA'},
          {value: 'SD', text: 'SOUTH DAKOTA'},
          {value: 'TN', text: 'TENNESSEE'},
          {value: 'TX', text: 'TEXAS'},
          {value: 'UT', text: 'UTAH'},
          {value: 'VA', text: 'VIRGINIA'},
          {value: 'VI', text: 'VIRGIN ISLANDS'},
          {value: 'VT', text: 'VERMONT'},
          {value: 'WA', text: 'WASHINGTON'},
          {value: 'WI', text: 'WISCONSIN'},
          {value: 'WV', text: 'WEST VIRGINIA'},
          {value: 'WY', text: 'WYOMING'},
        ],
      }
    },
    watch: {
      value() {
        this.state_province = this.value
      },
      state_province() {
        this.$emit('input', this.state_province)
      },
    }
  }
</script>